import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";

const Logout = () => {
  const [logout, setLogout] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("authToken")) {
      navigate("/login");
    }
  }, [logout, navigate]);

  const handleLogout = () => {
    localStorage.clear();
    setLogout(true);
    navigate("/login");
    window.location.reload();
  };

  return (
    <div
      className="modal fade"
      id="logoutModal"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        className="modal-dialog"
        style={{ marginLeft: "35rem", marginTop: "20%", width: "500px" }}
      >
        <div className="modal-content logout-content p-4">
          <p className="text-center">Are you sure you want to Logout ?</p>

          <div className="text-center mt-3 d-flex justify-content-center">
            <button
              className="btn me-3"
              data-bs-dismiss="modal"
              aria-label="Close"
              style={{
                border: "1px solid gray",
                color: "gray",
                width: "90px",
                height: "40px",
              }}
            >
              No
            </button>
            <button
              className="btn"
              style={{
                background: "#fff",
                color: "red",
                border: "1px solid red",
                width: "90px",
                height: "40px",
              }}
              onClick={handleLogout}
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Logout;
